import { TextKey } from '@mews-commander/enums';
import { Identifiable } from '@mews/std';
import { WithScope } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { ColumnAlignment } from '@mews/b2b-ui';
import { getFilesByIds } from '@mews-commander/legacy-entities/src/ducks/files';
import EntityTable from '../../entityManagement/components/EntityTable';
import { EntityDeleteButton } from '../../entityManagement/components/EntityDeleteButton';
import { createPagedEntityTableConnect } from '../../entityManagement';
import { FileDownloadLink } from '../../../components';

const mapping = [
    {
        valueKey: 'name',
        title: <LocalizedText textKey={TextKey.Name} />,
        render: ({ name, id }: { name: string; id: string }) => <FileDownloadLink name={name} id={id} />,
        columnWidth: '80%',
    },
    {
        valueKey: 'actions',
        title: <LocalizedText textKey={TextKey.ActionPlural} />,
        render: ({ id }: Identifiable, { scope, readOnlyForm }: WithScope & { readOnlyForm: boolean }) =>
            readOnlyForm ? null : <EntityDeleteButton id={id} scope={scope} />,
        columnWidth: '20%',
        columnAlignment: ColumnAlignment.Right,
    },
];

const FilesTable = EntityTable({ mapping });

// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export default createPagedEntityTableConnect(getFilesByIds)(FilesTable);
